/**
 * 薄埋点域壳：createTrackDomain(registry) → emit(key, detail) → pqTrack。
 * 失败吞掉，不抛错；业务域各自挂一份 entries。
 */
;(() => {
  if (typeof window.pqCreateTrackDomain === 'function') return

  function clean(params) {
    const out = {}
    if (!params || typeof params !== 'object') return out
    Object.keys(params).forEach((key) => {
      const value = params[key]
      if (value == null || value === '') return
      if (typeof value === 'boolean') out[key] = value ? 'true' : 'false'
      else if (typeof value === 'number') out[key] = value
      else out[key] = String(value)
    })
    return out
  }

  function pickContext(detail, pick) {
    if (typeof pick === 'function') return pick(detail) || {}
    if (!detail || typeof detail !== 'object') return {}
    const params = {}
    const groupId = detail.group_id || detail.groupId || detail.slug || ''
    const groupName = detail.group_name || detail.groupName || ''
    const itemId = detail.item_id || detail.itemId || detail.uuid || ''
    const itemName = detail.item_name || detail.itemName || detail.title || ''
    const productId = detail.product_id || detail.productId || ''
    const productHandle = detail.product_handle || detail.productHandle || ''
    const entry = detail.entry_position || detail.entryPosition || detail.source || ''
    const pageSource = detail.page_source || detail.pageSource || ''
    const category =
      detail.category_id != null
        ? detail.category_id
        : detail.categoryId != null
          ? detail.categoryId
          : undefined
    if (groupId) params.group_id = groupId
    if (groupName) params.group_name = groupName
    if (itemId) params.item_id = itemId
    if (itemName) params.item_name = itemName
    if (productId) params.product_id = productId
    if (productHandle) params.product_handle = productHandle
    if (entry) params.entry_position = entry
    if (pageSource) params.page_source = pageSource
    if (category != null && category !== '') params.category_id = category
    if (detail.operation_path) params.operation_path = detail.operation_path
    if (detail.success != null && detail.success !== '') {
      params.success = detail.success === true || detail.success === 'true' ? 'true' : 'false'
    }
    if (detail.from_group_id) params.from_group_id = detail.from_group_id
    return params
  }

  function createTrackDomain(options) {
    const opts = options && typeof options === 'object' ? options : {}
    const entries = opts.entries && typeof opts.entries === 'object' ? opts.entries : {}
    const entrySet = new Set(Array.isArray(opts.entryValues) ? opts.entryValues : [])
    const pick = opts.pick

    function emit(key, detail) {
      try {
        const def = entries[key]
        if (!def || !def.name) return false
        if (typeof window.pqTrack !== 'function') return false
        const params = Object.assign({}, def.defaults || {}, pickContext(detail, pick))
        if (def.needsEntry) {
          const entry = String(params.entry_position || '').trim()
          if (!entry || (entrySet.size > 0 && !entrySet.has(entry))) return false
        }
        return window.pqTrack(def.name, clean(params))
      } catch (error) {
        return false
      }
    }

    return {
      emit,
      entries,
      entryValues: entrySet,
    }
  }

  window.pqCreateTrackDomain = createTrackDomain
})()
